module.exports = __webpack_public_path__ + "assets/img/06b.0e157b61.png";